import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

export const Label = styled("label")(() => ({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: 0.1,
  color: "#0055A4",
  "& > span": {
    color: "#f04438",
  },
}));

export const CheckboxWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: 32,
}));

export const ErrorMessage = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.1,
  color: "#D92D20",
  display: "flex",
  alignItems: "center",
  gap: 5,
}));

export const ErrorWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  marginTop: "-10px",
  marginBottom: "10px",
}));

const styles = makeStyles<Theme>((theme) => ({
  modalWidth: {
    width: "45vw",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  sectionWidth: {
    width: "100%",
  },
  skeletonWidth: {
    width: "100%",
  },
}));

export default styles;
